export default __webpack_public_path__ + "static/media/companian-banner.251f662b.png";